import { SET_CURRENT_USER, SET_CSRF_TOKEN } from '../../constants';

export const setCurrentUser = (currentUser) => ({ type: SET_CURRENT_USER, payload: currentUser });

export const setCSRFToken = (token) => ({ type: SET_CSRF_TOKEN, payload: token });
